// 创建大仓库
import { createPinia } from 'pinia'
import piniaPluginPersist from 'pinia-plugin-persist'
// createPinia方法可以用于创建大仓库
const store = createPinia()
store.use(piniaPluginPersist)

// 向外暴露store仓库
export default store